/****************
* 封装vue全局操作方法
****************/
// import store from '../store'

export default{
  // install(Vue,options){
  	/*------------- cookie 操作 start -------------*/
    //获取cookie
    getCookie (name) {
		let arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
		if (arr = document.cookie.match(reg))
		return (arr[2]);
		else
		return null;
	},
	
	//设置cookie
	setCookie (c_name, value, expiredays) {
		let exdate = new Date();
		exdate.setDate(exdate.getDate() + expiredays);
		document.cookie = c_name + "=" + escape(value) + ((expiredays == null) ? "" : ";expires=" + exdate.toGMTString());
	},

	//删除cookie
	removeCookie (name) {
		let exp = new Date();
		exp.setTime(exp.getTime() - 1);
		let cval = this.getCookie(name);
		if (cval != null)
		document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
	}
		/*------------- cookie 操作 end -------------*/

  }
// }


// WEBPACK FOOTER //
// ./src/common/util.js